var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha",class:{ 'is-invalid': _vm.invalid }},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.key,"load-recaptcha-script":true},on:{"verify":_vm.verify,"expired":_vm.expired}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }